import { takeEvery } from "redux-saga/effects";

import * as applicationsActions from "../actions/applications";
import * as loginActions from "../actions/auth";
import * as feedbackActions from "../actions/feedback";
import * as jobsActions from "../actions/jobs";
import * as reviewsActions from "../actions/reviews";
import * as placeStatsActions from "../actions/stats";
import * as summaryActions from "../actions/stats";
import * as usersActions from "../actions/users";
import { changePasswordSaga, loginSaga } from "./auth";
import { fetchFeedbackSaga } from "./feedback";
import {
  banJobSaga,
  cancelJobSaga,
  fetchApplicationsSaga,
  fetchJobDetailSaga,
  fetchJobsSaga
} from "./jobs";
import { fetchReviewsSaga, removeReviewSaga } from "./reviews";
import { fetchPlaceStatsSaga } from "./stats";
import { fetchGeneralStatsSaga } from "./stats";
import { blockUserSaga, fetchUserDetailSaga, fetchUsersSaga, removeUserSaga } from "./users";

export function* watchAuth() {
  yield takeEvery(loginActions.LOGIN_REQUEST, loginSaga);
  yield takeEvery(loginActions.CHANGE_PASSWORD_REQUEST, changePasswordSaga);
}

export function* watchDashboard() {
  yield takeEvery(summaryActions.STATS_GENERAL_REQUEST, fetchGeneralStatsSaga);
  yield takeEvery(placeStatsActions.STATS_PLACES_REQUEST, fetchPlaceStatsSaga);
}

export function* watchJobs() {
  yield takeEvery(jobsActions.JOBS_FETCH_REQUEST, fetchJobsSaga);
  yield takeEvery(
    applicationsActions.APPLICATIONS_FETCH_REQUEST,
    fetchApplicationsSaga
  );
  yield takeEvery(jobsActions.JOB_DETAIL_FETCH_REQUEST, fetchJobDetailSaga);
  yield takeEvery(jobsActions.JOB_BAN_REQUEST, banJobSaga);
  yield takeEvery(jobsActions.JOB_CANCEL_REQUEST, cancelJobSaga);
}

export function* watchUsers() {
  yield takeEvery(usersActions.USERS_FETCH_REQUEST, fetchUsersSaga);
  yield takeEvery(usersActions.USER_DETAIL_FETCH_REQUEST, fetchUserDetailSaga);
  yield takeEvery(usersActions.USER_BLOCK_REQUEST, blockUserSaga);
  yield takeEvery(usersActions.USER_REMOVE_REQUEST, removeUserSaga);
}

export function* watchReviews() {
  yield takeEvery(reviewsActions.REVIEWS_FETCH_REQUEST, fetchReviewsSaga);
  yield takeEvery(reviewsActions.REVIEW_REMOVE_REQUEST, removeReviewSaga);
}

export function* watchFeedback() {
  yield takeEvery(feedbackActions.FEEDBACK_FETCH_REQUEST, fetchFeedbackSaga);
}



// WEBPACK FOOTER //
// ./src/store/sagas/index.ts